var ezdia;
(function (ezdia) {
    function developerBtn(_a) {
        var type = _a.type, label = _a.label, title = _a.title;
        return "<button title=\"" + title + "\" type=\"button\" data-type=\"" + type + "\" class=\"btn btn-warning\">" + label + "</button>";
    }
    function developer(id, cokkiesSet) {
        var _a = ezdia.CONST.DEV_COOKIE_KEYS, DEBUG = _a.DEBUG, TEST = _a.TEST;
        var btnHtmlArray = [];
        if (cokkiesSet.has(DEBUG)) {
            btnHtmlArray.push(developerBtn({
                type: DEBUG,
                label: 'D',
                title: "Debug mode is enabled. Click on button to disable 'debug mode."
            }));
        }
        if (cokkiesSet.has(TEST)) {
            btnHtmlArray.push(developerBtn({
                type: TEST,
                label: 'P',
                title: "Prodb environment is enabled. Click on button to disable 'Prodb environment'."
            }));
        }
        return "<div id=\"" + id + "\" class=\"devlopment-info btn-group\">\n      " + btnHtmlArray.join('') + "\n    </div>";
    }
    var templates;
    (function (templates) {
        templates.app = {
            developer: developer
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
